import React from 'react';
import { IAuditoriaDespesasAntecipadasResultado } from '../interfaces/IAuditoriaDespesasAntecipadas';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaDespesasAntecipadasResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Amortização de Despesas Antecipadas — verifica se contas de
// Despesas Antecipadas (Ativo Circulante) tiveram amortização mensal registrada. A omissão
// infla o Lucro Líquido e gera desembolso indevido de 34% de IRPJ/CSLL (CPC 27 / RIR 2018).
const AuditoriaResumoDespesasAntecipadas: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = (resultado.despesasEstagnadas?.length || 0) + (resultado.quebraCompetenciaMensal?.length || 0);

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Amortização — Despesas Antecipadas</h3>
      <p className='text-muted'>
        Auditoria complementar — despesas antecipadas (Ativo Circulante) sem amortização mensal inflam o Lucro Líquido
        e geram desembolso indevido de 34% de IRPJ/CSLL (CPC 27 / RIR 2018, Art. 311). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_DESPESAS_ANTECIPADAS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Amortização de Despesas Antecipadas</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} ocorrência{totalOcorrencias === 1 ? '' : 's'} de estagnação ou quebra de competência identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>34% IRPJ/CSLL + Multa ECD potencial (5% limitada a 1% da receita bruta) + multa por quebra de competência (Art. 12 Lei 8.218/1991)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoDespesasAntecipadas;
